<template>
    <el-form :label-width="labelWidth">
        <el-form-item label="指定时间段">
            <ly-date-picker width="220px" v-model="dateRange"></ly-date-picker>
        </el-form-item>    
        <el-form-item label="查询方式">   
            <el-radio-group v-model="formData.searchType">
                <el-radio label="1">按客户查询</el-radio>
                <el-radio label="2">按货品查询</el-radio>
            </el-radio-group>
        </el-form-item>                               
        <el-form-item label="指定批次">   
            <ly-batch width="220px" v-model="formData.pici"></ly-batch>
        </el-form-item>
        <el-form-item label="经营团队">
            <ly-select width="220px" api="api/jingyingtd" v-model="formData.jytd"></ly-select>
        </el-form-item>
        <el-form-item label="指定个别客户">
            <el-checkbox label="全部" name="type" v-model="isCustomer"></el-checkbox>
            <div style="width: 842px;">
            <ly-product-table v-if="!isCustomer" :thead-config="customerConfig" ref="customer"></ly-product-table>
            </div>
        </el-form-item>
    </el-form>
</template>
<script>
    import LyDatePicker from '@c/date_picker'
    import LySelect from '@c/select'
    import LyBatch from '@c/batch'
    import LySearchForm from '@c/search-form'
    import LyProductTable from '@c/product-table'
    /**
     * 三包理赔费用查询
     * @author zjs
     * @time 2018-04-09
     */
    export default {
        props: {
            customerConfig: Array
        },
        components: {
            LyDatePicker,
            LySearchForm,
            LySelect, 
            LyBatch,
            LyProductTable
        },
        data () {
            return {
                labelWidth: '100px', 
                dateRange: '',
                isCustomer: true,
                searchType: [{id: 1, name:'按客户查询'},{id: 2,name: '按货品查询'}],
                formData: {
                    ticket: 'sblpfy',
                    date_start: "",
                    date_end: "",
                    searchType: '1',
                    jytd: "",   
                    customer: [],
                    pici: ""  
                }
            }
        },
         watch: {
            'dateRange' (v) { // 三包理赔明细查询时间段拆分赋值
                this.formData.date_start = v.split("~")[0];
                this.formData.date_end = v.split("~")[1];
            }
        },
        mounted () {
            // 初始化指定时间段，默认为当天
            let today = this.$utils.dateFormat('yyyy-MM-dd',new Date())
            this.dateRange = today + "~" + today
        },
        methods: {
            /**
             * 获得表单数据
             */
            getFormData () {
                let customerIds = []
                if (Object.is(this.isCustomer,false)) {  
                    // 获取已选数据的id集合
                    customerIds = this.$refs['customer'].getProductData().map((item) => {
                        return item.customer.customer_id   
                    });
                    // 数组去重
                    customerIds = Array.from(new Set(customerIds)); 
                } 
                this.formData.customer = customerIds // 获取客户列表
                return this.formData
            }
        }
    }
</script>